var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4.67566C12.75 4.26145 12.4142 3.92566 12 3.92566C11.5858 3.92566 11.25 4.26145 11.25 4.67566L11.25 11.9257H4C3.58579 11.9257 3.25 12.2614 3.25 12.6757C3.25 13.0899 3.58579 13.4257 4 13.4257H11.25V20.6757C11.25 21.0899 11.5858 21.4257 12 21.4257C12.4142 21.4257 12.75 21.0899 12.75 20.6757V13.4257H20C20.4142 13.4257 20.75 13.0899 20.75 12.6757C20.75 12.2614 20.4142 11.9257 20 11.9257H12.75L12.75 4.67566Z",
    fill: "#2D264B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.2b031eb85905b227887c8cd8dfd3ce3c.svg";
export { ForwardRef as ReactComponent };